<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">Documents</h4>
</div>
<div class="modal-body">
    <p-table [value]="customerDocuments">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="3">
                    No Records Found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Document Type</th>
                <th class="w--date">Updated Date</th>
                <th class="w--status text-center">Select Document</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-expanded="expanded">
            <tr [pSelectableRow]="data">
                <td>
                    <a href="javascript:void(0)" (click)="downloadDocument(data.documentId)">{{ data.documentFilename }}</a>
                </td>
                <td>
                    {{ data.updatedDate | date:'M/d/yyyy' }}
                </td>
                <td>
                    <a class="icon--select" title="Select Document" href="javascript:void(0)" (click)="selectDocument(data)"></a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="icon--add btn--default" type="button" (click)="launchDocumentsModal()">Add New Document</button>
        <button class="btn--default" type="button" (click)="cancel()">Close</button>
    </div>
</div>